import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '../navigation/Breadcrumbs';
import { buildServiceBreadcrumbs } from '../navigation/breadcrumbUtils';
import './DataScienceAI.css';

const DataScienceAI = () => {
  const location = useLocation();
  const servicesIndexView = location.state?.servicesIndexView;
  const backPath = servicesIndexView ? '/services' : '/';

  const sections = [
    {
      title: 'Overview',
      content: (
        <p>
          Our Data Science and AI services help organizations uncover hidden
          patterns, predict outcomes, and optimize operations using
          data-driven models. We combine statistical analysis, machine
          learning, and domain expertise to deliver measurable business value.
        </p>
      ),
    },
    {
      title: 'Our Core Capabilities',
      content: (
        <p>
          We provide end-to-end AI and data solutions, from data preparation
          to production deployment, ensuring scalability, security, and
          long-term maintainability.
        </p>
      ),
    },
    {
      title: 'Services We Offer',
      content: (
        <ul className="data-science-ai-service-list">
          <li>Data Analysis & Visualization</li>
          <li>Machine Learning Model Development</li>
          <li>Predictive & Prescriptive Analytics</li>
          <li>Natural Language Processing (NLP)</li>
          <li>Computer Vision Solutions</li>
          <li>AI-Powered Automation</li>
          <li>Big Data Processing & Analytics</li>
          <li>Model Deployment & MLOps</li>
        </ul>
      ),
    },
    {
      title: 'Business Impact',
      content: (
        <p>
          Our AI-driven solutions enable businesses to improve operational
          efficiency, reduce costs, enhance customer experiences, and make
          faster, data-backed decisions. Every solution is designed with
          measurable ROI and real-world impact in mind.
        </p>
      ),
    },
    {
      title: 'Technology Stack',
      content: (
        <p>
          We work with modern and industry-proven technologies including
          Python, TensorFlow, PyTorch, Scikit-learn, SQL/NoSQL databases,
          cloud-based AI platforms, and scalable data pipelines.
        </p>
      ),
    },
    {
      title: 'Security & Compliance',
      content: (
        <p>
          BlackRoth follows best practices for data security, privacy, and
          compliance. Our solutions align with enterprise security standards
          and ensure responsible AI usage across all implementations.
        </p>
      ),
    },
  ];

  return (
    <div className="data-science-ai-page-wrapper">
      <div className="data-science-ai-page-container">
        <Breadcrumbs
          items={buildServiceBreadcrumbs('services', 'Data Science with AI')}
        />

        {/* Back Navigation */}
        <div className="data-science-ai-back-link">
          <Link
            to={backPath}
            state={servicesIndexView ? { servicesIndexView } : undefined}
          >
            {servicesIndexView ? '\u2190 Back' : '\u2190 Back to Home'}
          </Link>
        </div>

        {/* Hero Section */}
        <div className="data-science-ai-page-hero">
          <h1>Data Science &amp; AI Services</h1>
          <p>
            BlackRoth delivers advanced Data Science and Artificial Intelligence
            solutions that transform raw data into actionable intelligence,
            enabling smarter business decisions and automation at scale.
          </p>
        </div>

        {sections.map((section, index) => (
          <section className="data-science-ai-page-section" key={section.title}>
            <h2>{section.title}</h2>
            {section.content}
          </section>
        ))}
      </div>
    </div>
  );
};

export default DataScienceAI;

